module.exports = __webpack_public_path__ + "static/media/prince_hotel_home.5c446940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/prince_hotel_home.jpg
// module id = 498
// module chunks = 0